import React from 'react';
import './SmallLoader.scss'

export default function SmallLoader() {
    return (
        <div className="loader"/>
    );
}
